import path from "../../../../packages/fnacdarty-svg-ref-loader/svg-id.js?id=$!./icon_i_102_check_03.svg"; export default path + "#$"